import { apiBaseURL } from "../ProjectConstants";

async function handlePostProvideActionPO(comment, orderId, fetch) {
  const response = await fetch.post(
    `${apiBaseURL}/api/Approval/PurchaseOrder/ProvideAction?orderId=${orderId}&comment=${comment}`,
  );
  const isDataGood =
    response?.success &&
    response?.data?.statusCode &&
    response?.success !== "Invalid Model";

  return {
    response,
    isDataGood,
  };
}
export default handlePostProvideActionPO;
